<template>
  <div>
    <p
      v-if="module.type != 'theme'"
      class="mb-2 m-0"
    >
      <strong>{{ module.subject.name }}:</strong> {{ module.name }}
    </p>
    <p
      v-else
      class="mb-2 m-0"
    >
      <strong>{{ module.block.name }}:</strong> {{ module.name }}
    </p>
    <div class="my-2">
      <p class="mb-0 font-weight-normal">
        Módulo liberado a partir de 
        <span class="font-weight-bolder ">
          {{ $moment(module.begin_date).format('DD/MM/YYYY HH:mm') }}
        </span>
      </p>
      <p class="mb-0 font-weight-normal">
        Conclusão do módulo até 
        <span class="font-weight-bolder ">
          {{ $moment(module.end_date).format('DD/MM/YYYY HH:mm') }}
        </span>
      </p>
    </div>
    <div class="d-flex justify-content-between align-items-end">
      <button
        class="bg-transparent border-0 px-0"
        :disabled="cycle.cant_start_module"
        @click="onClick()"
      >
        <span class="align-middle">
          Acessar
        </span>
        <i class="fa fa-arrow-right align-middle" />
      </button>
    </div>
  </div>
</template>
<script>
  
  import { accessed_ebook } from '@/student/api/Ebook'
  import { showModuleRouteName } from '@/student/constants/routes';
  import { mapMutations } from 'vuex';

  export default {
    props: {
      module:{
        type:Object,
        required:true,
      },
      cycle:{
        type:Object,
        required:true,
      }
    },
    data(){
      return {
        showModuleRouteName,
      }
    },
    methods:{
      ...mapMutations(['SET_MODULE']),
      accessed_ebook,
      onClick(){
        this.SET_MODULE(null)
        this.$router.push( { name: showModuleRouteName, params: { module_id: this.module.id }})
      }
    },
  }
</script>
